import { FilterHandler, useFilterState } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import ChecklistTypesLoader, { useChecklistTypes } from './_load/ChecklistTypesLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectAllChecklistTypesLink from '../SelectAllChecklistTypesLink'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Footer = ({ onClose, onChange, multiple, filter }) => {
  const { filter: filterState, search } = useFilterState()
  const { form, handleChangeIn } = useFormState()

  return (
    <ModalPickerFooter closeModal={onClose} onChange={onChange}>
      {!!multiple && (
        <SelectAllChecklistTypesLink
          onSelect={handleChangeIn([])}
          value={form}
          useRawValues
          search={search}
          filter={{ ...filterState, ...filter }}
        />
      )}
    </ModalPickerFooter>
  )
}

const Content = props => {
  const options = useChecklistTypes()
  const { form, addIn, removeIn, handleChangeIn } = useFormState()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="name"
      {...props}
    />
  )
}

const ChecklistTypePickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('checklistTypes')

  return (
    <Modal width="32rem" noPadding open={open} onClose={() => onClose()} level={level}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader title={t('selectChecklistTypes')} useDeletedOption />
          <Line />

          <Scroll height="65vh">
            <ChecklistTypesLoader>
              <Content closeModal={onClose} {...props} />
            </ChecklistTypesLoader>
            <Separator weight={12} />
          </Scroll>

          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default ChecklistTypePickerModal
